import { Stack } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { useLocation } from 'react-router';
import { getAppRouteByPath } from '../../../constants/appRoutes';

const FetchingPage = () => {
  const { pathname } = useLocation();
  const currentMainPath = '/' + pathname.split('/')[1];
  const appRoute = getAppRouteByPath(currentMainPath);
  const { withInitialFetchAnimation } = appRoute ?? {};

  if (!withInitialFetchAnimation) {
    return null;
  }

  return (
    <Stack height="100%" justifyContent="center" alignItems="center" p={4} gap={6}>
      <Stack textAlign="center" gap={2}>
        <Typography variant="h2">Scanning your metadata for the first time</Typography>
        <Typography variant="h4" color={colors.grey[700]}>
          This may take a moment...
        </Typography>
      </Stack>
      <img src="/assets/fetchAnimation.gif" alt="Loading" width="50%" height="50%" />
    </Stack>
  );
};

export default FetchingPage;
